import React, { useEffect, useId, useRef } from 'react';

const ConfirmDialog = ({
  title,
  message,
  emoji,
  danger = false,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onResolve,
}) => {
  const titleId = useId();
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onResolve(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onResolve]);

  // Reason: only a click on the overlay itself dismisses; clicks bubbling out of
  // the modal share the same handler but must not close the dialog.
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onResolve(false);
  };

  return (
    <div className="overlay-clay z-50 flex items-center justify-center" onClick={handleOverlayClick}>
      <div
        className="modal-clay p-6 max-w-md mx-4"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        {emoji && (
          <div className="text-center mb-4">
            <span className="text-4xl" role="img" aria-hidden="true">{emoji}</span>
          </div>
        )}
        <h3 id={titleId} className="font-display text-lg font-bold text-heading mb-2 text-center">
          {title}
        </h3>
        {message && <p className="text-secondary-text mb-6 text-center">{message}</p>}
        <div className="flex justify-center gap-3">
          <button
            type="button"
            ref={cancelRef}
            onClick={() => onResolve(false)}
            className="btn-clay-ghost"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={() => onResolve(true)}
            className={danger ? 'btn-clay-danger' : 'btn-clay'}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
